export default __webpack_public_path__ + "6d9fafbcd95f97c6070132dddab75b13.svg";